import React from "react";

const LABELS = {
  saving: "Menyimpan...",
  saved: "Tersimpan",
  pending: "Belum disimpan — lengkapi terapi",
  error: "Gagal menyimpan",
};

// Status autosave (PUT …/conditions & …/therapies). Gaya: .mps-save (MasterPengobatanStandar).
const SaveStatus = ({ status, errors = [] }) => (
  <span className={`mps-save is-${status}`} role="status" title={errors.join("\n") || undefined}>
    <span className="mps-save-dot" />
    {LABELS[status]}
  </span>
);

export default SaveStatus;
